import z from "zod";

const MAX_FILE_SIZE = 1024 * 1024 * 100;
export const ACCEPTED_IMAGE_MIME_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

export const ImageFileSchema = z.file().mime(ACCEPTED_IMAGE_MIME_TYPES).min(1).max(MAX_FILE_SIZE);

export const ImageSchema = z.union([ImageFileSchema, z.string().min(1)]).optional();

export const SvgFileSchema = z
  .file()
  .mime(["image/svg+xml"])
  .min(1)
  .max(1024 * 1024 * 1);

export const SvgSchema = z.union([SvgFileSchema, z.string().min(1)]).optional();
